



















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { IOption, IRadioProps } from "./Radio.dto";

@Component({})
export default class Radio extends Vue {
  @Prop({
    default: () => [],
  })
  readonly options!: IRadioProps;
  @Prop({ default: [] }) value!: IOption["value"][];
  @Prop({ type: Boolean, default: false }) isMultipleSelect!: boolean;

  private selectedItems: IOption["value"][] = [];

  @Watch("value", { immediate: true })
  watchValue(newVal: IOption["value"][]) {
    this.selectedItems = [...newVal];
  }

  onSelect(item: IOption["value"]) {
    if (!this.isMultipleSelect) {
      this.selectedItems = [item];
    } else {
      const isAvail = this.selectedItems.includes(item);
      this.selectedItems = isAvail
        ? this.selectedItems.filter((i) => i !== item)
        : [...this.selectedItems, item];
    }
    this.$emit("input", this.selectedItems);
  }
}
